import { useEffect, useRef } from 'react';

import { useQueryClient } from '@tanstack/react-query';

import type { CommunitySpaceAccessMap } from '~/interfaces/community';

import { communityMemberPostsKeys } from './useCommunityMemberPosts';
import { communityPostsKeys } from './useCommunityPosts';

export const useRefetchFeedsOnAccessChange = (spaceAccess: CommunitySpaceAccessMap) => {
  const queryClient = useQueryClient();
  const accessStates = Object.entries(spaceAccess)
    .map(([spaceId, { state }]) => `${spaceId}:${state}`)
    .join();
  const previousAccessStates = useRef(accessStates);

  useEffect(() => {
    if (previousAccessStates.current === accessStates) return;
    previousAccessStates.current = accessStates;
    // Joins the refetch the answer modal starts with the reload, instead of restarting it after the overlay drops.
    queryClient.invalidateQueries({ queryKey: communityPostsKeys.all }, { cancelRefetch: false });
    queryClient.invalidateQueries({ queryKey: communityMemberPostsKeys.all }, { cancelRefetch: false });
  }, [accessStates, queryClient]);
};
